function Component() {
  window.location.replace("https://dwp.digitalwholesalesolutions.com");
  return null;
}

export default Component;
